"use strict";

exports.__esModule = true;
exports.formatPinnedFile = formatPinnedFile;
exports.formatTag = formatTag;
exports.getGlobal = getGlobal;
exports.getGlobalFetch = getGlobalFetch;
exports.toSwarmHash = toSwarmHash;

function formatPinnedFile(p) {
  return {
    address: p.Address,
    counter: p.PinCounter,
    raw: p.IsRaw,
    size: p.FileSize
  };
}

function formatTag(t) {
  return {
    uid: t.Uid,
    name: t.Name,
    address: t.Address,
    total: t.Total,
    split: t.Split,
    seen: t.Seen,
    stored: t.Stored,
    sent: t.Sent,
    synced: t.Synced,
    startedAt: new Date(t.StartedAt)
  };
}

function getGlobal() {
  // ES2020
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  } // Browser window


  if (typeof window !== 'undefined') {
    return window;
  } // Web Worker


  if (typeof self !== 'undefined') {
    return self;
  }

  throw new Error('Unable to get global object');
}

function getGlobalFetch() {
  var global = getGlobal();
  return global.fetch.bind(global);
}

function toSwarmHash(buffer) {
  return Buffer.from(new Uint8Array(buffer)).toString('hex');
}